import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { useGetSessionQuery } from '../api/apiSlice';
import { Suspense } from 'react';

const AdminRoute = () => {
    const { data: session, isLoading } = useGetSessionQuery();
    const location = useLocation();

    // Need to implement a guard for admin routes 
    
    const isAdmin = session?.claims?.['accounts.superuser'] === "True" || false;
    return isAdmin
        ? <Suspense><Outlet /></Suspense>
        : <Navigate to="/" state={{ from: location }} replace />;
}

export default AdminRoute;